import React, { useState } from "react";
import { useAuth } from "utilities/auth";

function AuthSocial(props) {
  const auth = useAuth();
  const [pending, setPending] = useState(null);

  const providerDisplayNames = {
    google: "Google",
    // Add other providers here when needed
  };

  const onSigninWithProvider = (provider) => {
    setPending(provider);
    auth
      .signinWithProvider(provider)
      .then((user) => {
        localStorage.setItem("lastUsedAuthProvider", provider);
        props.onAuth(user);
      })
      .catch((error) => {
        setPending(null);
        props.onError(error.message);
      });
  };

  return (
    <div className="mt-4">
      {props.providers.map((provider) => (
        <div className="mb-2" key={provider}>
          <button
            type="button"
            onClick={() => onSigninWithProvider(provider)}
            disabled={pending === provider}
            className="w-full rounded-md border border-brand bg-background text-foreground px-4 py-2 text-sm font-medium hover:border-brand hover:text-brand transition focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2 disabled:opacity-50"
          >
            {pending === provider
              ? "..."
              : `${props.buttonAction} with ${providerDisplayNames[provider]}`}
          </button>
        </div>
      ))}
    </div>
  );
}

export default AuthSocial;
